import _ from 'lodash';

import environment from '../../environment';
import sideBar from '../sidebar';

const LayerControls = (name) => require('../../controls').get(name);

const tour = () => {
    const steps = [{
        element: '#trigger-sidebar',
        title: 'Por onde começar?',
        content: 'Para começar a navegar clique neste botão.',
        name: 'Por onde começar',
        onShow () {
            this.delay = 1000;
            return sideBar.close();
        }
    }, {
        element: '#sidebar-container',
        title: 'Barra Lateral',
        content: 'Esta é a barra lateral do NeoGIG. Ela contém todas as camadas do sistema.',
        onShow () {
            this.delay = 1000;
            return sideBar.open();
        }
    }];

    const featuresSteps = _(environment.get('FEATURES'))
        .reduce((res, val, key) => {
            const feat = LayerControls(key);
            if (val && feat.get()) {
                res.push({
                    element: `#${key.toLowerCase()}-sidebar`,
                    title: feat.get().label,
                    content: feat.get().help,
                    onShow () {
                        this.delay = false;
                        sideBar.open();
                    }
                });
            }
            return res;
        }, []);

    return steps.concat(featuresSteps);
};

export default tour;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/sidebar.js